// Keep in ascending order with `= 1` on first because `0` is not a valid z-index value
export const ZIndex = {
  FilterButton: 1,
  ContactCheckout: 2,
  Header: 3,
  CookieInfoRenew: 5,
  SiteBanner: 6,
  ImboxChat: 7,
  StickyAddToCart: 8,
  MobileMenu: 9,
  CookiePopup: 10,
  Overlay: 11,
  FacetMobileButtons: 12,
  Modal: 13,
  Spinner: 14,
};
